import defaultFetch from 'isomorphic-fetch';
import formUrlEncoded from 'form-urlencoded';
import defaultFetchRetry from './fetch.retry';
import RetryError from './utils/retryError';

/* eslint prefer-template: "off" */
export const createApiClient = (apiClientConfig) => {
  const defaultConfig = {
    fetch: defaultFetch,
    fetchRetry: defaultFetchRetry
  };

  const { fetch, fetchRetry } = Object.assign({}, defaultConfig, apiClientConfig);

  return {

    handleRetryFailure(response) {
      if (response.retryTimeout) {
        throw new RetryError('All retries failed.', response);
      }
      return response;
    },

    handleErrors(response) {
      if (response.status >= 500) {
        window.location.assign('/clapply/cl/CLError.action');
        return null;
      } else if (!response.ok) {
        let plainText;
        return response.text()
          .then(text => {
            plainText = text;
            return text;
          })
          .then(text => JSON.parse(text))
          .catch(() => Promise.reject([{ description: plainText }]))
          .then(err => Promise.reject(err.errors));
      } else {
        return response;
      }
    },

    async handleRedirect(response) {
      if (response.status === 303) {
        let path = await response.json();
        window.location.assign(path);
        return null;
      } else {
        return response;
      }
    },

    handleSuccess(response) {
      const EMPTY_JSON = '{}';
      return response.text()
        .then(text => text ? text : EMPTY_JSON)
        .then(JSON.parse)
        .catch(() => Promise.reject([{ description: 'There was a problem with the response' }]));
    },
    handleNetworkErrors(error) {
      return Promise.reject([{ description: `Please check that you are connected to the internet: ${error}` }]);
    },

    extendSession() {
      return fetch('/clapply/cl/CLCyr.action?extendSession', {
        credentials: 'include',
        method: 'GET'
      })
        .then(this.handleErrors)
        .then(this.handleSuccess);
    },
    postForm(url, formData, actionName, headers) {
      const body = formData ? formUrlEncoded(formData) + `&${actionName}=` : `${actionName}=`;
      return fetch(url, {
        credentials: 'include',
        method: 'POST',
        body: body,
        headers: Object.assign({
          'Content-Type': 'application/x-www-form-urlencoded'
        }, headers)
      })
        .catch(this.handleNetworkErrors)
        .then(this.handleRedirect)
        .then(this.handleErrors)
        .then(this.handleSuccess);
    },
    getWithRetries(url, retryOptions) {
      return fetchRetry(fetch, url, {
        credentials: 'include',
        method: 'GET'
      }, retryOptions)
        .catch(this.handleNetworkErrors)
        .then(this.handleRetryFailure)
        .then(this.handleErrors)
        .then(this.handleSuccess);
    },
    fetchWithRetries(url, actionName, retryOptions, formData) {
      const body = formData ? formUrlEncoded(formData) + `&${actionName}=` : `${actionName}=`;
      return fetchRetry(fetch, url, {
        credentials: 'include',
        method: 'POST',
        body: body,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }, retryOptions)
        .catch(this.handleNetworkErrors)
        .then(this.handleRetryFailure)
        .then(this.handleErrors)
        .then(this.handleSuccess);
    },
    postDelayAPI(url, formData, actionName, headers, delay) {
      const body = formData ? formUrlEncoded(formData) + `&${actionName}=` : `${actionName}=`;
      const promise = new Promise(((resolve, reject) => {
        window.setTimeout(() => {
          fetch(url, {
            credentials: 'include',
            method: 'POST',
            body: body,
            headers: Object.assign({
              'Content-Type': 'application/x-www-form-urlencoded'
            }, headers)
          })
            .catch((response)=>{
              reject(response);
            })
            .then((response)=>{
              if(response.ok){
                response.text().then((data)=>resolve(JSON.parse(data)));
              }else{
                response.text().then((data)=>reject(data));
              }
            });
        }, delay);
      }));
      return promise;
    },
    uploadDocuments(url, formData) {
      return fetch(url, {
        credentials: 'include',
        method: 'POST',
        body: formData
      })
        .catch(this.handleNetworkErrors)
        .then(this.handleRedirect)
        .then(this.handleErrors)
        .then(this.handleSuccess);
    },

    extendSessionXsell() {
      return fetch('/clapply/action/customizeOffer/extendSession', {
        credentials: 'include',
        method: 'GET'
      })
        .then(this.handleErrors)
        .then(this.handleSuccess);
    }
  };
};

export default createApiClient;
